"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.chat.nomodel': '选择模型开始聊天',
};
